export default "__VITE_ASSET__BZPpA4Mv__"